<template>
  <div class="pc-end flex flex-col" v-if="!disableSubmit">
    <div class="flex-1">
      <!--      <div class="icon-box text-center">-->
      <!--        <template v-if="overData.success">-->
      <!--          <template v-if="$bus.award">-->
      <!--            <template v-if="awardYuanAmount">-->
      <!--              <img width="160" src="~@/assets/img/answer/award.png" />-->
      <!--            </template>-->
      <!--            <template v-else-if="!hasReward">-->
      <!--              <img src="~@/assets/img/answer/regret.png" alt="" width="160" />-->
      <!--            </template>-->
      <!--          </template>-->
      <!--          <img width="160" v-else-if="$bus.share" src="~@/assets/img/answer/award.png" />-->
      <!--          <img width="160" v-else src="~@/assets/img/answer/success.png" alt="" />-->
      <!--        </template>-->
      <!--        <template v-else>-->
      <!--          <img src="~@/assets/img/answer/error.png" alt="" />-->
      <!--        </template>-->
      <!--      </div>-->
      <split-box class="mt-4">
        <template v-slot:top-content>
          <answer-text />
        </template>
        <template v-slot:bottom-content>
          <answer-operate v-if="answerId"/>
        </template>
      </split-box>

      <answer-audit class="mt-4" />
      <award-answer-wrapper v-if="showAward" class="mt-4"/>
<!--      <answer-award  />-->
      <survey-point v-if="surveyPoint" class="mt-4" />

      <template v-if="enableLuck">
        <div>
          <luck v-if="showLuck" :answer-id="answerId" :survey-id="surveyId" :bindEnabled="bindEnabled" />
        </div>
      </template>
      <more-survey v-if="enableMoreSurvey" class="mt-4" />
      <!--      <div class="text-center">-->
      <!--        <el-button v-if="viewableAfterSubmit" type="text" @click="onPreview">查看已填内容</el-button>-->
      <!--      </div>-->
      <!--      <div class="btn-group flex justify-center mt-2">-->
      <!--        <el-button @click="onShare">分享一下</el-button>-->
      <!--        <el-button type="primary" v-if="enableMoreSurvey" @click="onToTask">更多问卷</el-button>-->
      <!--      </div>-->
    </div>
    <div ref="footerContainer" class="relative py-5 text-center">
      <div class="copyright text-theme-black-450">
        <!-- <span>调研工厂 提供技术支持</span> |
        <a target="_blank" class="text-medium text-theme-black-450" href="https://survey.work/s/mZZZZfiJ">举报</a> -->
        <!-- 网站协议文案提示 -->
        <DygcFooter v-if="isDygcFooter" isReport />
        <template v-if="answerId">
          <div class="text-small mt-2" @click="onCopyAnswerId">
            <span>{{ answerId }}</span>
            <span class="cursor-pointer">
              <img src="~@/assets/img/svg/copy.svg" />
            </span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'dygc-ui'
import Luck from 'components/luck/Luck'
import AnswerAudit from '@/components/end/AnswerAudit'
import AnswerText from '@/components/end/AnswerText'
import AnswerAward from '@/components/end/AnswerAward'
import { AnswerStatus, busGetters, getStatusConfig } from 'dygc'
import { createPopup } from '@/assets/js/factory'
import SharePopup from '@/components/popup/SharePopup'
import AnswerOperate from '@/components/end/AnswerOperate'
import SplitBox from '@/components/SplitBox'
import MoreSurvey from '@/components/end/MoreSurvey'
import DygcFooter from 'components/dygc-footer-bottom/index'
import SurveyPoint from '@/components/end/SurveyPoint'
import AwardAnswerWrapper from '@/components/reward/AwardAnswerWrapper.vue'

export default {
  name: 'PcEnd',
  components: { AwardAnswerWrapper, SurveyPoint, MoreSurvey, SplitBox, AnswerOperate, AnswerAward, AnswerText, AnswerAudit, Luck, DygcFooter },
  data() {
    return {
      footerStatus: false,
      footerStatusPreview: false
    }
  },
  computed: {
    disableSubmit() {
      return this.$bus.params.disableSubmit
    },
    showAward() {
      return [AnswerStatus.OK, AnswerStatus.PASS, AnswerStatus.QUALITY].includes(this.overData.status)
    },
    bindEnabled() {
      return [AnswerStatus.OK, AnswerStatus.PASS].includes(this.overData.status)
    },
    awardYuanAmount() {
      return this.overData?.awardYuanAmount
    },
    hasReward() {
      return this.overData?.hasReward
    },
    overData() {
      return this.$bus.overData
    },
    surveyId() {
      return this.$bus.survey.id
    },
    isDygcFooter() {
      if(this.$bus.params.isTest === 'true') {
        return this.footerStatusPreview
      }
      return this.footerStatus
    },
    ...busGetters([
      'viewableAfterSubmit',
      'enableNetManualAudit',
      'enableMoreSurvey',
      'answerId',
      'enableLuck',
      'showLuck',
      'surveyPoint'
    ])
  },
  created() {
    // 答题换壳
    const companyId= this.$bus.survey.companyId
    if(!companyId) return
    getStatusConfig(companyId, ['out_D55_D', 'wj_F77']).then(res => {
      if (res?.code !== 0) return
      this.footerStatus = res.data.out_D55_D === '1'
      this.footerStatusPreview = res.data.wj_F77 === '1'
    })
  },
  methods: {
    onShare() {
      if (this.$bus.share) {
        const url = this.$bus.getUrl(1)
        createPopup(SharePopup, {
          isTest: this.$bus.params.isTest,
          url
        })
      } else {
        window.navigator.clipboard.writeText(window.location.href)
        Message({
          message: '复制成功',
          type: 'success'
        })
      }
    },
    onToTask() {
      window.location.replace(process.env.VUE_APP_TASK_HALL)
    },
    onPreview() {
      if (this.$bus.params.isTest) {
        Message({
          type: 'warning',
          message: '测试链接不支持此功能'
        })
        return
      }
      this.$router.push({
        name: 'preview',
        params: {
          id: this.$bus.answerId
        }
      })
    },
    onCopyAnswerId() {
      window.navigator.clipboard.writeText(this.answerId)
      Message({
        message: '复制成功',
        type: 'success'
      })
    }
  }
}
</script>
